// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import OrderNotify from "components/Notifications/order_notify";
import Select from "components/Input/select";
// Application
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Infrastructure
import { PlansAPI } from "views/Plans/infrastructure";
// Vendor
import { getIncidencesDate, getOrderBody } from "vendor/application";
import { getCountries } from "vendor/application/countries";
import "views/Order/styles/index.scss";
import { BillingAPI } from "../infrastructure";

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: this.props.plan,
      order: { ...getOrderBody(), plan: this.props.plan },
      disable: {
        phone: false,
        country: false
      },
      countries: getCountries(),
      incidence: getIncidencesDate(),
      request: { isDone: false, type: false }
    };
  }

  componentDidMount() {
    this.handlePlan(this.props.plan);
    this.getAccountInfo();
  }

  getAccountInfo = async () => {
    const { disable } = this.state;
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      let res = await obj.get_account();

      var order = this.state.order,
        info = res.superadmin;
      if (res && info) {
        order.firstname = info.first_name;
        order.lastname = info.last_name;
        order.country = res.country ? res.country : "";
        order.phone = res.phone ? res.phone : "";
        order.email = info.email;

        disable.country = order.country ? true : false;
        disable.phone = order.phone ? true : false;
      }
      this.setState({ order: order });
    } catch (error) {}
  };

  handlePlan = (plan) => {
    this.setState({ plan: plan });
  };

  // update element state
  updateElement(e, type) {
    const { order } = this.state;
    const obj = new ElementsHandleAPI(order, e.target.value, type);
    const res = obj.updateObj();

    this.setState({ order: res });
  }

  contact = async () => {
    const { access } = this.props.data;
    try {
      const obj = new PlansAPI(access, this.props, this.state.order);
      await obj.post_interest();
      this.setState({ request: { isDone: true, type: "success" } });
    } catch (err) {
      this.setState({
        request: {
          isDone: true,
          type: "error",
          error: err.responseJSON.message
        }
      });
    }
  };

  handleAction = (e) => {
    e.preventDefault();
    switch (this.state.request.type) {
      case "error":
        this.setState({ request: { isDone: false, type: "" } });
        break;
      case "success":
        this.props.history.push("/");
        break;
    }
  };

  updateCountry = (e) => {
    this.state.order.country = e;
    this.setState({ order: this.state.order });
  };

  updateInteraction = (e) => {
    this.state.order.interactions = e;
    this.setState({ order: this.state.order });
  };

  render() {
    const { plan, incidence, order, countries, request, disable } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        {!request.isDone ? (
          plan && (
            <React.Fragment>
              <div className="man-order">
                <div className={this.props.plan}>
                  <div className={`man-header ${this.props.plan}`}>
                    <div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t(`plans:${plan}.name`)
                        }}
                      ></p>
                    </div>
                  </div>
                  <div className="man-content">
                    <div className="man-sub_header">
                      <span>{t("description")}</span>
                    </div>
                    <div className="man-sub_content">
                      <input
                        disabled
                        id={"name_input_contact"}
                        placeholder={t("inputs:input.firstname_placeholder")}
                        name="firstname"
                        value={order.firstname}
                        onChange={(e) => this.updateElement(e, "firstname")}
                        type="text"
                      />
                      <input
                        disabled
                        id={"lastname_input_contact"}
                        placeholder={t("inputs:input.lastname_placeholder")}
                        name="lastname"
                        value={order.lastname}
                        onChange={(e) => this.updateElement(e, "lastname")}
                        type="text"
                      />
                      <Select
                        disabled={disable.country}
                        strSelected={order.country}
                        array={countries}
                        onSelect={this.updateCountry}
                        placeholder={t("inputs:input.country_placeholder")}
                        value={"name"}
                        id={"select-billing-country"}
                        t={t}
                      />
                      <input
                        disabled={disable.phone}
                        id={"phone_input_contact"}
                        type="number"
                        placeholder={t("inputs:input.phone_placeholder")}
                        name="phone"
                        value={order.phone}
                        onChange={(e) => this.updateElement(e, "phone")}
                      />
                      <input
                        disabled
                        id={"email_input_contact"}
                        autoComplete="nope"
                        placeholder={t("inputs:input.email_placeholder")}
                        name="email"
                        value={order.email}
                        onChange={(e) => this.updateElement(e, "email")}
                        type="email"
                      />
                      <div></div>
                    </div>
                    <div className="man-sub_content incidence">
                      <span>{t("incidences")}</span>
                      <Select
                        strSelected={
                          order.interactions
                            ? t(`inputs:selector.order.${order.interactions}`)
                            : ""
                        }
                        array={incidence}
                        onSelect={this.updateInteraction}
                        placeholder={t("inputs:input.select_placeholder")}
                        value={"name"}
                        type={"incidence"}
                        id={"select-billing-province"}
                        t={t}
                      />
                    </div>
                    <div className="man-actions">
                      <button
                        id={"btn_contact"}
                        onClick={(e) => this.contact(e)}
                        className="btn btn-green"
                      >
                        {t("button_contact")}
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div className={`man-header ${this.props.plan}`}>
                    <span>{t("title_solution")}</span>
                  </div>
                  <div className="man-content">
                    <p>{t("description_solution")}</p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        ) : (
          <div className="man-order notify">
            <div className={this.props.plan}>
              <div className={`man-header ${this.props.plan}`}>
                <div>
                  <p>
                    <span>{plan.name}</span> <span>{plan.last}</span>
                  </p>
                </div>
              </div>
              <div className="man-content">
                <OrderNotify
                  domain={"order"}
                  onClick={this.handleAction}
                  type={request.type}
                  error={request.error}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Contact);
export default withTranslation(["order", "plans", "inputs", "billing"])(
  withRouter(connect_)
);
